export interface IIndexedDbTileOptions {
    /**
     * Name of the database
     *
     * The default value is equal to the constant DEFAULT_DATABASE_NAME
     * @default "tile-cache-data"
     */
    databaseName?: string;

    /**
     * Object store to use for operation status
     *
     * The default value is equal to the constant DEFAULT_OPERATION_OBJECT_STORE_NAME
     * @default "op-status"
     */
    operationObjectStoreName?: string;

    /**
     * Object store to use for tiles
     *
     * The default value is equal to the constant DEFAULT_TILE_OBJECT_STORE_NAME
     * @default "tiles"
     */
    tileObjectStoreName?: string;

    /**
     * Object store to use for tiles
     *
     * The default value is equal to the constant DEFAULT_OPERATION_EVENT_CHANNEL_NAME
     * @default "tile-op-status"
     */
    eventBroadcastChannelName?: string;

    /**
     * The default value is equal to the constant DEFAULT_OPERATION_HISTORY_MAX_AGE_DAYS
     * @default 30
     */
    operationHistoryMaxAgeDays?:  number;
}

/**
 * Interface for the options parameter of the constructor of the IndexedDbTileCache class
 */
export interface IIndexedDbTileCacheOptions extends IIndexedDbTileOptions {
    /**
     * Error/missing tile URL.
     *
     * The default value is equal to the constant DEFAULT_ERROR_TILE_URL
     */
    errorTileUrl?: string;

    /**
     * The maximum age in milliseconds of a stored tile.
     *
     * The default value is equal to the constant DEFAULT_REFETCH_AGE_DAYS
     * @default 1000 * 60 * 60 * 24 * 7
     */
    tileRefetchAgeDays?: number;

    seedStrategy?: TileCacheSeedStrategy;

    uiTitleOpInProgress?: string;

}

export enum TileCacheSeedStrategy {
    All = 0,
    OnlyMissingOrStale = 1
}

export interface IIndexedDbTileCacheWorkerOptions extends IIndexedDbTileOptions {
    uiTitleOpFailed?: string;
    uiTitleOpSuccess?: string;
}

/**
 * Interface for an internal IndexedDbTileCacheEntry
 */
export interface IIndexedDbTileCacheEntry {
    /**
     * URL of the tile except its sub-domain value that is still stored as placeholder.
     */
    url: string;
    /**
     * Timestamp of the creation date of the entry
     */
    timestamp: number;
    /**
     * Data stored as Uint8Array enhanced with node.js' Buffer
     */
    data: ArrayBuffer;
    /**
     * The content-type from the response header.
     */
    contentType: string;
}